import { GET_DISCOVER_DETAILS } from './actionTypes'

export function getDiscoverDetails (data) {
    return {
        type: GET_DISCOVER_DETAILS,
        payload: data
    }
}
